"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const dateFns = require('date-fns');
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
const { HAS_PASSED } = require('../definitions/operators');
const { DAY, WEEK, MONTH, YEAR } = require('../definitions/durationUnits');
const { generateDateEqualsExpression, generateDateAfterExpression, generateOrExpression, } = require('../definitions/factory/expressionFactory');
exports.accepts = ({ operator }) => operator === HAS_PASSED;
exports.resolve = ({ right, left }, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    assert(right);
    assert(left);
    const { context: { durationUnit }, } = right;
    assert(durationUnit);
    const leftResolved = yield resolveExpression(left, context);
    const rightResolved = yield resolveExpression(right, context);
    let afterDate;
    switch (durationUnit) {
        case DAY:
            afterDate = dateFns.addDays(leftResolved, rightResolved);
            break;
        case WEEK:
            afterDate = dateFns.addWeeks(leftResolved, rightResolved);
            break;
        case MONTH:
            afterDate = dateFns.addMonths(leftResolved, rightResolved);
            break;
        case YEAR:
            afterDate = dateFns.addYears(leftResolved, rightResolved);
            break;
        default:
            throw new Error('Duration unit is not valid');
    }
    const expressionEvaluationDate = new Date(Date.now()).toISOString();
    const afterValue = afterDate.toISOString();
    const afterExpression = generateDateAfterExpression({
        leftValue: expressionEvaluationDate,
        afterValue,
    });
    const equalsExpression = generateDateEqualsExpression({
        leftValue: expressionEvaluationDate,
        rightValue: afterValue,
    });
    // Has passed is inclusive of the first day in range
    const afterOrEqualExpression = generateOrExpression({
        operands: [afterExpression, equalsExpression],
    });
    return resolveExpression(afterOrEqualExpression, context);
});
//# sourceMappingURL=hasPassedExpression.js.map